import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import rate from 'vue-rate'

import VueMaterial from 'vue-material'
import 'vue-material/dist/theme/default.css'
import 'vue-material/dist/vue-material.min.css'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import '@/assets/css/main.css'
import '@/assets/scss/main.scss'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import VueLoading from 'vuejs-loading-plugin'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import * as Constants from '@/store/constants'

require('vue2-animate/dist/vue2-animate.min.css')

if (Constants.DEBUG) {
  Sentry.init({
    environment: Constants.ENV,
    dsn: 'http://a23aa4b6621f4df785e3f0a62137e264@str.telecom.pt:9000/8',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
} else {
  Sentry.init({
    environment: Constants.ENV,
    dsn: 'http://a23aa4b6621f4df785e3f0a62137e264@:domain/8'.replace(':domain', Constants.DOMAIN),
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
}

Vue.use(VueLoading)

Vue.use(VueSweetalert2)

Vue.use(rate)

Vue.use(BootstrapVue)

Vue.use(VueMaterial)

Vue.config.productionTip = Constants.PRODUCTION

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
